// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-465ac328]:root{--light_text_color:#666}.cart__payment-options--stripe[data-v-465ac328]{margin-top:10px!important;min-height:50px}.cart__payment-options--stripe .stripe-button-loading[data-v-465ac328]{min-height:50px;display:flex;justify-content:center;align-items:center;width:100%}.cart__payment-options--stripe #express-checkout-element[data-v-465ac328]{margin-top:10px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
